import React, { createContext, useContext } from "react"
import { StubTranslations } from "./implementation/StubTranslations"
import { ITranslations } from "./types"

const TheContext = createContext<ITranslations>(StubTranslations)

interface IProps {
  translations: ITranslations;
  children: any;
}

export function TranslationsProvider(props: IProps) {
  const { children, translations } = props
  return <TheContext.Provider value={translations}>{children}</TheContext.Provider>
}

export function useTranslations() {
  const context = useContext(TheContext)
  if (context === undefined) {
    throw new Error("[useTranslations]")
  }

  return context
}
